export const xs = '0px'
export const sm = '576px'
export const md = '768px'
export const lg = '992px'
export const xl = '1200px'
export const xxl = '1400px'

export const mobile = '500px'
